import { T } from 'consts/translationKeys'

export enum ZOrderAction {
  BringToFront = 'bringToFront',
  BringToBack = 'bringToBack',
  BringForward = 'bringForward',
  BringBackward = 'bringBackward'
}

export type TMenuRow =
  | {
      type: 'item'
      action: ZOrderAction
      labelKey: T
      icon: React.ReactNode
      id: number
    }
  | { type: 'divider'; id: number }

export interface IZOrderContextMenuPosition {
  x: number
  y: number
}

export interface IZOrderContextMenuProps {
  position: IZOrderContextMenuPosition
  onClose: () => void
  onSelect: (action: ZOrderAction) => void
}
